import React, { Component } from 'react'

import { Link, Redirect } from 'react-router-dom'
import { Button, ButtonGroup, Row, Col } from 'react-bootstrap';

import Loading from '../../components/shared/Loading'

import { SignupForm } from './SignupForm'
import { Message } from './Message'
import { AccountMigrate } from './AccountMigrate'

import { signUp } from '../../../lib/authentication'

import { createIdentityMap } from '../utils'

import routes from '../../constants/routes'

import './auth.scss'

const Stages = createIdentityMap(
  'ENTERING_USERNAME',
  'SUBMITTING_SIGNUP',
  'LOGIN_EXISTS',
  'FORGOT_PASSWORD_MIGRATED',
  'INVITED_INVITE',
  'INVITED_WHITELIST',
  'REQUEST_ACCESS_REJECTED',
  'INVALID_SIGNUP'
)

const Status = createIdentityMap('LOGIN', 'FORGOT_PASSWORD', 'INVITED', 'FAIL', 'REQUEST_ACCESS')
const Reason = createIdentityMap('EXISTS', 'MIGRATED', 'INVITE', 'WHITELIST', 'REJECTED')

export default class Signup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      username: '',
      error: { errorSummary: '', errorItems: [] },
      stage: Stages.ENTERING_USERNAME,
    }
  }

  setError(errorSummary, ...errorItems) {
    this.setState({ error: { errorSummary, errorItems } })
  }

  setStage(stage) {
    this.setState({ stage })
  }

  isOnStage(...stages) {
    return stages.includes(this.state.stage)
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  handleFormSubmit = async (event) => {
    event.preventDefault()

    this.setError()
    this.setStage(Stages.SUBMITTING_SIGNUP)

    const { status, reason } = await signUp(this.state.username)
    console.log('STATUS:', status, 'REASON:', reason)

    if (status === Status.INVITED) {
      if (reason === Reason.INVITE) this.setStage(Stages.INVITED_INVITE)
      if (reason === Reason.WHITELIST) this.setStage(Stages.INVITED_WHITELIST)
      return
    }

    if (status === Status.LOGIN) {
      this.setStage(Stages.LOGIN_EXISTS)
      return
    }

    if (status === Status.FORGOT_PASSWORD) {
      this.setStage(Stages.FORGOT_PASSWORD_MIGRATED)
      return
    }

    if (status === Status.REQUEST_ACCESS) {
      this.setStage(Stages.REQUEST_ACCESS_REJECTED)
      return
    }

    this.setError('Unknown Error occurred', 'Please try again')
    this.setStage(Stages.ENTERING_USERNAME)
  }

  validateForm = () => {
    const { username } = this.state
    const isProbablyEmail = username.length && /^.+@.+\..+$/.test(username)
    return isProbablyEmail
  }

  renderForm() {
    const { username } = this.state
    return (
      <SignupForm
        onSubmit={this.handleFormSubmit}
        onChange={this.handleChange}
        validateForm={this.validateForm}
        username={username}
      >
        {this.isOnStage(Stages.INVALID_SIGNUP) && this.renderErrors()}
      </SignupForm>
    )
  }

  renderErrors() {
    const { error: { errorSummary = 'Unknown Error Ocurred', errorItems = [] } = {} } = this.state
    return (
      <Message title={errorSummary} type="danger">
        {errorItems.map(errorItem => (<p key={btoa(errorItem)}>{errorItem}</p>))}
      </Message>
    )
  }

  renderLoginExistsMessage() {
    return (
      <Row>
        <Col xs={6} xsOffset={3}>
          <Message title="Account already exists" type="success">
            <p>The email address submitted is already associated with an Owner&apos;s Edge Account</p>
            <p>Try <Link to={routes.LOGIN}>logging in here</Link></p>
            <p>If you cannot remember your password, <Link to={routes.FORGOT_PASSWORD}>try resetting it</Link></p>
          </Message>
        </Col>
      </Row>
    )
  }

  renderInvitedInviteMessage() {
    return (
      <Message title="Invite sent" type="success">
        <p>You&apos;ve been invited to join Owner&apos;s Edge!</p>
        <p>You should be receiving an email soon with instructions on how to complete your invitation</p>
      </Message>
    )
  }

  renderInvitedWhitelistMessage() {
    return (
      <Message title="Invite sent" type="success">
        <p>You&apos;ve been invited to join Owner&apos;s Edge!</p>
        <p>You should be receiving an email soon with instructions on how to complete your invitation</p>
      </Message>
    )
  }


  renderRequestAccessRejected() {
    return <Redirect to={routes.REQUEST_ACCESS + `?email=${encodeURIComponent(this.state.username)}`} />
  }

  render() {
    return (
      <div className="AuthContainer container vertical">
        {this.isOnStage(Stages.SUBMITTING_SIGNUP) && <Loading classes="loading" />}
        {this.isOnStage(Stages.ENTERING_USERNAME, Stages.INVALID_SIGNUP) && this.renderForm()}
        {this.isOnStage(Stages.LOGIN_EXISTS) && this.renderLoginExistsMessage()}
        {this.isOnStage(Stages.INVITED_INVITE) && this.renderInvitedInviteMessage()}
        {this.isOnStage(Stages.INVITED_WHITELIST) && this.renderInvitedWhitelistMessage()}
        {this.isOnStage(Stages.FORGOT_PASSWORD_MIGRATED) && <AccountMigrate username={this.state.username} />}
        {this.isOnStage(Stages.REQUEST_ACCESS_REJECTED) && this.renderRequestAccessRejected()}
      </div>
    )
  }
}
